<template>
  <v-layout column fluid>
    <DialogAskForString ref="dlgSaveFilterRuleset"
      title="TITLE_SM_DIALOG_SAVEFILTERSET"
    ></DialogAskForString>
    <v-layout column ref='currentRuleset'>
      <v-layout row blue style="color: white;">
        <v-flex md4 pa-0 align-center>
          <v-layout row>
            <v-flex shrink align-content-center>
              <v-menu offset-x>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on" color="white" class="pointer body-1 ml-2 pa-2" >fa fa-bars</v-icon>
                </template>
                <v-list>
                  <v-list-tile @click="saveFilterRuleset">
                    <v-list-tile-title class="body-1">{{ 'LISTENTRY_SAVE_RULES' | translate }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="loadFilterRuleset('factorydefault')" :disabled="filterRules.length <= 0">
                    <v-list-tile-title class="body-1">{{ 'LISTENTRY_DELETE_ALL_RULES' | translate }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider v-if="filterRulesets.length > 0"></v-divider>
                  <v-subheader class="caption" v-if="filterRulesets.length > 0"> {{ 'TITLE_SAVED_RULESSETS' | translate }}</v-subheader>
                  <v-list-tile v-for="filterRuleset in filterRulesets" :key="filterRuleset.id" @click="loadFilterRuleset(filterRuleset.title, $event)">
                    <v-list-tile-title class="body-1">{{ filterRuleset.title }}</v-list-tile-title>
                    <v-list-tile-action class="body-1"><v-icon @click.stop="deleteFilterRuleset(filterRuleset.title)">delete</v-icon></v-list-tile-action>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
            <v-flex pa-0 align-self-center shrink>
              {{ 'TITLE_CURRENT_RULES' | translate }}
            </v-flex>
            <v-flex shrink>
              <v-btn :disabled="filterRules.length <= 0" dark class="pa-0 text-none blue" @click.native="loadFilterRuleset('factorydefault')" small>
                {{ 'LABEL_DELETE_ALL_RULES' | translate }}
              </v-btn>
            </v-flex>
            <v-flex shrink>
              <v-btn v-if="!showManager" dark class="pa-0 text-none blue" @click.native="onActionButtonClick" small>
                {{ labels['actionButton'] }}
              </v-btn>
            </v-flex>
            <v-spacer></v-spacer>            
          </v-layout>
        </v-flex>
        <v-flex md1 offset-md5>
          <v-btn v-if="hitlistMode == 'balances'" color="white" class="text-none" outline small @click="showLoadPeergroupDialog()">
            {{ 'BUTT_LOAD_PEERGROUP'| translate}}
          </v-btn>
        </v-flex>
        <v-flex align-content-center md2>
          <v-menu offset-x :close-on-content-click="false" v-model="dsMenu" @input="onDatasourceMenu($event)">
            <template v-slot:activator="{ on }">
              <v-flex v-on="on" pointer>
                {{ 'CELL_TITLE_QUELLE' | translate }}:
                <span v-if="currentDataSources.length > 0">{{ dataSources.length > 0 && dataSources.find((e)=> e.id == currentDataSources[0]).title }}</span>
                <span v-if="currentDataSources.length > 1" class="grey--text caption">&nbsp; (+{{ currentDataSources.length - 1 }})</span>
              </v-flex>
            </template>
            <v-list >
              <v-list-tile v-for="(ds, index) in dataSources" :key="ds.id" @click="toggleDatasource(ds)">
                <v-list-tile-action><v-switch v-model="dsSelection" :value="ds.id" @click=""></v-switch></v-list-tile-action>
                <v-list-tile-title class="body-1 " >{{ ds.title }}</v-list-tile-title>
              </v-list-tile>
              <v-divider ></v-divider>
              <v-list-tile>
                <v-flex justify-center>
                <v-btn @click="onDatasourceMenu(false)" color="#004884" small dark outline class="radiusBtn text-none"> {{'BUTT_OK' | translate}}</v-btn>
              </v-flex>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-layout row justify-start align-start>
        <v-flex pa-1 v-if="filterRules.length == 0">{{ 'TITLE_NO_RULES' | translate }}</v-flex>
        <v-flex md11>
          <v-list dense>
            <v-list-tile v-for="rule in filterRules" :key="rule.nr" @click="onSearchItemManagerClick('', rule.filter.id, rule.nr, rule.data)" class="autoheight">
              <v-list-tile-action>
                {{ rule.nr }}
              </v-list-tile-action>
              <v-list-tile-action>
                <v-checkbox v-model="rule.enabled" @click.stop="enableDisableRule(rule.nr)" ></v-checkbox>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-icon @click.stop="deleteRule(rule.nr)">delete</v-icon>
              </v-list-tile-action>
              <v-list-tile-action>
                <v-icon @click="">edit</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <div>{{ rule.displayText }}</div>
              </v-list-tile-content>
              <v-list-tile-action>
                <span v-if="rule.hits != '-'">{{ rule.hits }}<SqlDetails v-if="rule.sql" :timeTaken="rule.time" :sqlStatement="rule.sql"></SqlDetails></span>
                <span v-else><v-icon class="icon-spinner">gps_not_fixed</v-icon></span>
              </v-list-tile-action>
            </v-list-tile>
            <v-list-tile v-if="filterRules.length > 0" avatar>
              <v-list-tile-content>
                <v-flex style="width: 95%">
                  <v-text-field v-model="formula" @change="onFormulaChange" class="mx-0" :label="'TOOLTIP_SQL_FORMULA' | translate" clearable>
                  </v-text-field>
                </v-flex>
              </v-list-tile-content>
              <v-list-tile-action>
                <span v-if="totalHits != '-'">{{ totalHits }}<SqlDetails v-if="totals.sql" :timeTaken="totals.time" :sqlStatement="totals.sql"></SqlDetails></span>
                <span v-else><v-icon class="icon-spinner">gps_not_fixed</v-icon></span>
              </v-list-tile-action>
            </v-list-tile>
          </v-list>
        </v-flex>
        <v-flex md1 align-self-end>
          <v-btn v-if="filterRules.length > 0 && showManager" dark class="text-none blue" @click.native="onActionButtonClick" small>
            {{ labels['actionButton'] }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>
    </v-layout>
    <v-layout row>
      <v-flex v-if="showManager" pa-0 ma-0>
        <v-layout justify-start row>
          <v-flex md3>
            <SearchItemManager defaultTab="groups" itemType="filters" eventNewFilter="SearchItemManagerClick" :containerHeight="innerHeight">
            </SearchItemManager>
          </v-flex>
          <v-divider vertical :style="{ height: 38+innerHeight+'px'}"></v-divider>
          <v-flex md9 >
            <v-layout column v-if="currentSearchItem">
              <v-layout row align-self-start ma-2 pl-2 pt-2>
                <v-flex subheading>
                  {{ currentSearchItem.title }}
                </v-flex>
                <v-flex caption v-if="currentSearchItem.uiElement === 'vertpos'" class="ml-2 pl-2 ma-0 pa-0">
                  <v-checkbox v-model="showVertposIDs" :label="'LABEL_SHOW_IDS' | translate" class="ml-2 pl-2 ma-0 pa-0"></v-checkbox>
                </v-flex>
              </v-layout>
              <v-flex>
                <v-text-field v-if="currentSearchItem.uiElement === 'input'" v-model="currentItemData['value']" :suffix="suffix"
                  :clearable="true" :label="currentSearchItem.title" class="pa-2 ma-2" height="30px" @keyup="onKeyUp" persistent-hint
                  :hint="currentSearchItem.compareOperator==='fulltext' ? $t('HINT_QUERY_FULLTEXT') : ''">
                </v-text-field>

                <v-list v-if="currentSearchItem.uiElement === 'multiSelectCombo'" :style="{overflow: 'auto', height: innerHeight + 'px'}">
                  <v-list-tile style="height:32px;" v-for="entry in currentSearchItem.uiList" :key="entry.id" @click="">
                    <v-list-tile-action>
                      <v-checkbox v-model="currentItemData['selection']" :value="entry" multiple></v-checkbox>
                    </v-list-tile-action>
                    <v-list-tile-content @click="onChange($event, currentSearchItem, entry)"">
                      <v-list-tile-title v-html="entry.title"></v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
            
                <v-layout column v-if="currentSearchItem.uiElement === 'citySelect' || currentSearchItem.uiElement === 'countrySelect'">
                  <SearchItemQuerySelector :refFilterId="null" :currentData="currentItemData['selection']" :searchArea="currentSearchArea"
                    eventUpdateQuerySelection="onUpdateQuerySelection" :containerHeight="innerHeight-124"
                  >
                  </SearchItemQuerySelector>
                </v-layout>

                <v-layout column v-if="currentSearchItem.uiElement === 'geopos'">
                  <SearchItemGeoSelector v-if="currentSearchItem.uiElement === 'geopos'" :refFilterId="null" :currentData="currentItemData" 
                    eventUpdateQuerySelection="onUpdateQuerySelection" :containerHeight="innerHeight-124">
                  </SearchItemGeoSelector>
                  <span class="v-label theme--light">{{ currentSearchItem.title }}</span>
                  <v-layout align-center justify-space-around row>
                    <v-flex md4 class="myField">
                      <v-text-field
                        v-model="currentItemData['latitude']"
                        :label="labels['latitude']"
                        class="mr-2"
                        height="20px"
                        @keyup="onKeyUp"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md4 class="myField">
                      <v-text-field
                        v-model="currentItemData['longitude']"
                        :label="labels['longitude']"
                        class="mr-2"
                        height="20px"
                        @keyup="onKeyUp"
                      ></v-text-field>
                    </v-flex>
                    <v-flex md3 class="myField">
                      <v-text-field
                        v-model="currentItemData['radius']"
                        :label="labels['radius']"
                        :suffix="currentItemData['radius'] ? 'km' : ''"
                        class="mr-0"
                        height="20px"
                        @keyup="onKeyUp"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-layout>

                <v-layout column v-if="currentSearchItem.uiElement === 'vertpos' || currentSearchItem.uiElement === 'range'">
                  <v-flex md12 v-if="currentSearchItem.uiElement === 'vertpos'">
                    <v-flex lg5 md12>
                      <v-autocomplete v-model="currentItemData['subitemgroup']" return-object
                        :clearable="false" :label="currentSearchItem.grouptitle" :items="currentSearchItem.uiList" browser-autocomplete="new-password"
                        item-text="title" item-value="id" class="pa-2 ma-2 mb-0 pb-0" height="30px" dense hide-details @change="onVertposGroupChange">
                        <template v-if="!showVertposIDs" v-slot:item="{ item }">{{  item.title }}</template>
                        <template v-else v-slot:item="{ item }">{{  item.title + " (" + item.id + ")" }}</template>
                      </v-autocomplete>
                    </v-flex>
                    <v-autocomplete v-model="currentItemData['subitem']" return-object
                      :clearable="true" :label="currentSearchItem.title" :items="currentSearchItem.uiSubList" browser-autocomplete="new-password"
                      item-text="title" item-value="id" class="pa-2 ma-2 mb-0 pb-0 singlelineitems" height="30px" dense hide-details @change="onSubitemChange">
                      <template v-slot:item="{ item }">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <div v-on="on" class="singlelineitems">{{  item.title }}<span v-if="showVertposIDs">{{" (" + item.id + ")" }}</span></div>
                          </template>
                          <span class="max-w-500">{{  item.title }}</span>
                        </v-tooltip>
                      </template>
                    </v-autocomplete>
                  </v-flex>
                  <v-layout md12 v-if="currentSearchItem.uiYears">
                    <v-flex lg5 md12>
                      <v-autocomplete v-model="currentItemData['year']" return-object
                        :clearable="true" label="Jahr" :items="currentSearchItem.uiYears" multiple browser-autocomplete="new-password"
                        item-text="title" item-value="id" class="pa-2 ma-2" height="30px" dense>
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout md12>
                    <v-flex lg6 md12>
                      <v-layout align-center justify-space-around row>
                        <v-flex md4 class="myField">
                          <div class="v-input v-text-field theme--light" style="margin-right: 10px !important;" v-if="maskedInput">
                            <div class="v-input__control">
                              <div class="v-input__slot" style="height: 20px;">
                                <div class="v-text-field__slot">
                                  <label class="v-label theme--light" style="left: 0px; right: auto; position: absolute;"></label>
                                  <imask-input
                                    v-model="currentItemData['lwb']" 
                                    :mask="Number"
                                    thousandsSeparator="."
                                    :placeHolder="labels['from']"
                                    :scale="maskedScale"
                                    radix=","
                                    @keyup="onKeyUp"
                                  >
                                  </imask-input>
                                  <div class="v-text-field__suffix">{{suffix}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <v-text-field v-if="!maskedInput"
                            v-model="currentItemData['lwb']"
                            :label="labels['from']"
                            :suffix="suffix"
                            hide-details
                            class="pa-2 ma-2"
                            height="20px"
                            @keyup="onKeyUp"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md4 class="myField">
                          <div class="v-input v-text-field theme--light" style="margin-right: 10px !important;" v-if="maskedInput">
                            <div class="v-input__control">
                              <div class="v-input__slot" style="height: 20px;">
                                <div class="v-text-field__slot">
                                  <label class="v-label theme--light" style="left: 0px; right: auto; position: absolute;"></label>
                                  <imask-input
                                    v-model="currentItemData['upd']" 
                                    :mask="Number"
                                    thousandsSeparator="."
                                    :placeHolder="labels['to']"
                                    :scale="maskedScale"
                                    radix=","
                                    @keyup="onKeyUp"
                                  >
                                  </imask-input>
                                  <div class="v-text-field__suffix theme--light">{{suffix}}</div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <v-text-field v-if="!maskedInput"
                            v-model="currentItemData['upb']"
                            :label="labels['to']"
                            :suffix="suffix"
                            hide-details
                            class="pa-2 ma-2"
                            height="20px"
                            @keyup="onKeyUp"
                          ></v-text-field>
                        </v-flex>
                        <v-flex md2 v-if="currentSearchItem.unitNr === 2">
                          <v-select v-model="currentItemData['waehrungsdimensionNr']" :items="currencyDimensions" theme--light dense
                            item-value="id" item-text="name" height="20px" single-line :label="'CURRENCY_DIMENSION'|translate"
                            class="ma-2 pa-2" hide-details @change="onCurrencyDimensionChange"
                            v-if="currencyDimensions.length > 0">
                          </v-select>
                        </v-flex>
                        <i aria-hidden="true" @click="doClear()" class="ma-1 pa-2 v-icon align-start v-icon--link theme--light material-icons">clear</i>
                        <v-spacer></v-spacer>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-layout>

                <v-layout column v-if="currentSearchItem.uiElement === 'rangeCombo'">
                  <v-layout md12 v-if="currentSearchItem.uiYears">
                    <v-flex lg5 md12>
                      <v-autocomplete v-model="currentItemData['year']" return-object
                        :clearable="true" label="Jahr" :items="currentSearchItem.uiYears" multiple browser-autocomplete="new-password"
                        item-text="title" item-value="id" class="pa-2 ma-2" height="30px" dense>
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                  <v-layout md12>
                    <v-flex lg5 md12>
                      <v-layout md12align-center justify-space-around row>
                        <v-flex md6 class="myField" ma-2 pa-2>
                          <v-select v-model="currentItemData['lwb']" :items="currentSearchItem.uiList" theme--light dense 
                            item-value="id" item-text="title" height="20px" :label="labels['from']" single-line>
                          </v-select>
                        </v-flex>
                        <v-flex md6 class="myField" ma-2 pa-2>
                          <v-select v-model="currentItemData['upb']" :items="currentSearchItem.uiList" theme--light dense
                            item-value="id" item-text="title" height="20px" :label="labels['to']" single-line>
                          </v-select>
                        </v-flex>
                        <i md1 aria-hidden="true" @click="doClear()" class="v-icon v-icon--link theme--light material-icons">clear</i>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-layout>

                <v-flex v-if="currentSearchItem.uiElement === 'branchSelect' || currentSearchItem.uiElement === 'gkzSelect' || currentSearchItem.uiElement === 'regionLandSelect'"
                  :style="{ height: innerHeight + 'px'}" align-content-start>
                  <v-text-field v-model="search"
                    :clearable="true" :label="labels['search']" class="ma-0 pa-0 pl-2 ml-2" height="30px">
                  </v-text-field>
                  <v-treeview :items="currentSearchItem.uiList" ref='theTree' @update:active="onUpdateTree($event)" :filter="itemIdTextFilter"
                    activatable :active.sync="currentItemData['selection']" :open.sync="openNodes" return-object :search="search" multiple-active
                    item-key='id' item-text="title" :style="{overflow: 'auto', height: (innerHeight - 50 - 16 - 50) + 'px'}">
                    <template v-slot:label="{ item, active }" v-if="currentSearchItem.uiElement === 'regionLandSelect'">
                      <span v-if="item.notselectable" >{{ item.title }}</span>
                      <span v-else class="pointer">
                        <span> {{ item.title }}</span>
                      </span>
                    </template>
                    <template v-slot:label="{ item, active }" v-else>
                      <span v-if="item.notselectable" >{{ item.title + " (" + item.id + ")" }}</span>
                      <span v-else class="pointer">
                        <span style="font-weight: 600">{{ item.id }}</span><span style="font-weight: 400">{{ item.idsuffix }}</span><span> {{ item.title }}</span>
                      </span>
                    </template>
                  </v-treeview>
                  <v-text-field v-model="currentSelection"
                    :clearable="true" readonly @click:clear="doClear()" :label="labels['currentSelection']" class="pa-2 ma-2" height="30px" @keyup="onKeyUp">
                  </v-text-field>
                </v-flex>
              </v-flex>
              <v-layout column style="height: 40px">
                <v-flex align-self-start>
                  <v-btn outline class="text-none" color="#004884" @click="onAddRule()" small>OK</v-btn>
                </v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
  import Vue from 'vue';
  import SearchItemManager from './SearchItemManager';
  import SearchItemGeoSelector from './SearchItemGeoSelector';
  import SearchItemQuerySelector from './SearchItemQuerySelector';
  import DialogAskForString from "../dialogs/DialogAskForString";
  import SqlDetails from "../../widgets/SqlDetails.vue";
  let _ = require('lodash');

  export default {
    name: 'SearchRulesManager',
    components: { SearchItemManager, SearchItemGeoSelector, SearchItemQuerySelector, DialogAskForString, SqlDetails },
    props: [ 'hitlistMode', 'showManager' ],
    data() {
      return {
        inLoop: false,
        filterRulesets: [],
        dataSources: [],
        currentDataSources: [],
        dsSelection: [],
        dsMenu: false,
        currentSearchData: null,
        currentItem: null,
        currentSearchItem: null,
        currentItemData: {},
        currentRule: 0,
        currentSearchArea: null,
        currentSelection: '',
        showVertposIDs: false,
        openNodes: [],
        formula: '',
        labels: {
          from: Vue.i18n.translate('LABEL_SITEM_FROM'),
          to: Vue.i18n.translate('LABEL_SITEM_TO'),
          latitude: Vue.i18n.translate('LABEL_SITEM_LAT'),
          longitude: Vue.i18n.translate('LABEL_SITEM_LONG'),
          radius: Vue.i18n.translate('LABEL_SITEM_RADIUS'),
          currentSelection: 'Aktuelle Auswahl',
          search: 'Suche',
          actionButton: '',
        },
        maskedInput: false, // TOD: Check usefullness
        maskedScale: '',
        currencyDimensions: [],
        suffix: '',
        innerHeight: 400,
        filterRules: [],
        totals: {},
        totalHits: '',
        search: '',
      }
    },
    watch: {
      showManager: function (newValue) {
        this.labels['actionButton'] = Vue.i18n.translate(newValue ? 'BUTT_HITLIST' : 'BUTT_EDIT');
      },
    },

    methods: {
      showLoadPeergroupDialog: function () {
        if (this.$parent.$refs.dlgSelectPeergroup) {
          this.$parent.showLoadPGDialog();
        }
      },
      onDatasourceMenu: function (opening) {
        if (opening) {
          Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', true);
          this.dsSelection = [];
          this.dsSelection.push(...this.currentDataSources);
        }
        else {
          this.dsSelection = _.uniq(this.dsSelection);
          if (_.difference(this.currentDataSources, this.dsSelection).length == 0 && _.difference(this.dsSelection, this.currentDataSources).length == 0) {
            this.dsMenu = false;
            return;
          }
          this.currentDataSources = [];
          this.currentDataSources.push(...this.dsSelection);
          Vue.prototype.$api.setSelectedSources(this.currentDataSources);
          this.dsMenu = false;

          for (let rule of this.filterRules) {
            this.updateHits([rule]);
          }
          if (this.filterRules.length > 1) {
            this.updateHits(this.filterRules);
          }
        }
      },
      toggleDatasource: function (ds) {
        const i = this.dsSelection.indexOf(ds.id)

        if (i > -1) {
          this.dsSelection.splice(i, 1)
        } else {
          this.dsSelection.push(ds.id)
        }

        if (this.dsSelection.length < 1) {
          this.dsSelection.push(this.currentDataSources[0]);
        }
      },
      doClear: function () {
        if (this.currentSearchItem.uiElement === 'branchSelect' || this.currentSearchItem.uiElement === 'gkzSelect' || currentSearchItem.uiElement === 'regionLandSelect') {
          this.currentItemData['selection'] = [];
        }
      },
      onUpdateTree: function (entry) {
        if (this.inLoop) return;
        const cmp = this;
        this.inLoop = true;
        this.$nextTick(function () {
          if (entry.length > 1) {
            const last = entry[entry.length-1];
            for (let o of cmp.$refs.theTree.getDescendants(last.id)) {
              const index = cmp.currentItemData['selection'].findIndex(function (item, index) { return item.id === o; });
              if (index > -1) {
                cmp.currentItemData['selection'].splice(index, 1);
              }
            }
            for (let o of cmp.$refs.theTree.getParents(last.id)) {
              const index = cmp.currentItemData['selection'].findIndex(function (item, index) { return item.id === o; });
              if (index > -1) {
                cmp.currentItemData['selection'].splice(index, 1);
              }
            }
          }

          const rule = {
            nr: this.currentRule ? this.currentRule : this.filterRules.length + 1,
            filter: this.currentSearchItem,
            data: JSON.parse(JSON.stringify(this.currentItemData)),
            enabled: true,
          }

          let filterRule = this.createSearchFilterFromFilterRule(rule);
          if (filterRule != null) {
            Vue.prototype.$api.getFilterRuleText(filterRule, function (data) {
              cmp.currentSelection = data.displayText;
            });
          }
          /*
          let newSelection = '';
          cmp.$refs.theTree.activeCache.forEach (function (y) {
            if (newSelection) {
              newSelection += '; ';
            }
            newSelection += y;
          });
          cmp.currentSelection = newSelection;
          */
          cmp.inLoop = false;
        });
      },
      itemIdTextFilter: function (item, queryText, itemText) {
        const qt = queryText.toLocaleLowerCase();
        return item[itemText].toLocaleLowerCase().indexOf(qt) > -1 || (item.id && item.id.toLocaleLowerCase().startsWith(qt));
      },
      onOpenNode: function (nodes) {
        Vue.prototype.$api.debug('onOpenNode', { nodes: nodes });
      },
      onChange: function (event, item, entry) {
        const index = this.currentItemData['selection'].findIndex(function (item, index) { return item.id === entry.id; });
        if (item.uiElement === 'multiSelectCombo') {
          if (index > -1) {
            this.currentItemData['selection'].splice(index, 1);
          }
          else {
            this.currentItemData['selection'].push(entry);
          }
        }
      },
      onCurrencyDimensionChange: function (event) {
        if (this.currentSearchItem.unitNr === 2) {
          let dim = this.currencyDimensions.find((e)=> e.id == this.currentItemData['waehrungsdimensionNr']);
          this.suffix = dim ? dim.name : '';
        }
      },
      onKeyUp: function (evt) {
        if (evt.code === 'Enter') {
          this.onAddRule();
          return;
        }
        if (evt.keyCode === 13) {
          this.onAddRUle();
          return;
        }
      },
      onSubitemChange: function (subFilter) {
        Vue.prototype.$api.debug('onSubitemChange', { subFilter: subFilter });
        const id = Vue.prototype.$api.createSearchFilterId (this.currentSearchItem.id, subFilter.id);
        //this.currentItemData = {};
        this.currentItemData['subitem'] = subFilter;
        this.prepareSearchItem(id, this.currentRule, undefined);
      },
      onVertposGroupChange: function (groupitem, selectIt) {
        const cmp = this;
        Vue.prototype.$api.debug('onVertposGroupChange', { groupitem: groupitem });
        Vue.prototype.$api.getFilterUiList(this.currentSearchItem.id, groupitem.id, function (data) {
          cmp.currentSearchItem.uiSubList = data;
          if (selectIt) {
            cmp.currentItemData.subitemgroup = cmp.currentSearchItem.uiList.find((e) => e.id == groupitem.id);
          }
          cmp.$forceUpdate();
        });
      },
      onSearchItemManagerClick: function (action, filterId, ruleNr, ruleData) {
        Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', true);
        this.currentItemData = {};
        this.prepareSearchItem(filterId, ruleNr, ruleData)
      },
      prepareSearchItem (filterId, ruleNr, ruleData) {
        const cmp = this;
        if (ruleData && ruleData['subitem']) {
          filterId = Vue.prototype.$api.createSearchFilterId (filterId, ruleData['subitem'].id);
        }
        Vue.prototype.$api.getFilterInfo (filterId, function(data) {
          Vue.prototype.$api.debug('prepareSearchItem', { filterId: filterId, nr: ruleNr, data: data });
          if (cmp.currentSearchItem && cmp.currentSearchItem.uiSubList) data.uiSubList = cmp.currentSearchItem.uiSubList;
          cmp.currentSearchItem = JSON.parse(JSON.stringify(data));
          switch (cmp.currentSearchItem.uiElement) {
            case 'input':
              cmp.currentItemData['value'] = '';
              break;
            case 'geopos':
              //cmp.currentItemData = {};
              break;
            case 'multiSelectCombo':
              cmp.currentItemData['selection'] = [];
              break;
            case 'citySelect':
              cmp.currentItemData['selection'] = [];
              cmp.currentSearchArea = 'cities';
              break;
            case 'countrySelect':
              cmp.currentItemData['selection'] = [];
              cmp.currentSearchArea = 'countries';
              break;
            case 'vertpos':
              cmp.currentItemData['waehrungsdimensionNr'] = '';
              cmp.currentSearchItem['uiList'].unshift ({
                id: 0,
                title: Vue.i18n.translate('LABEL_DD_ALL'),
              });
              let itemidparts = filterId.match(/^([^_]+)(?:_(.*))?/);
              if (itemidparts.length > 1 && itemidparts[2] !== undefined) {
                Vue.prototype.$api.getFilterUiList(itemidparts[1], 0, function (dataUiList) {
                  Vue.prototype.$api.debug('getFilterUiList callback', { dataUiList: dataUiList });
                  cmp.currentSearchItem.uiSubList = dataUiList;
                  //cmp.currentItemData.subitemgroup = data.subGroup;
                  if (data.subGroup) {
                    cmp.currentItemData.subitemgroup = cmp.currentSearchItem.uiList.find((e) => e.id == data.subGroup);
                  }
                  if (itemidparts[2]) {
                    cmp.currentItemData['subitem'] = cmp.currentSearchItem.uiSubList.find((e)=> e.id == itemidparts[2]);
                  }
                  cmp.$forceUpdate();
                });
              } else if (cmp.currentItemData.subitemgroup === undefined) {
                //cmp.currentItemData.subitemgroup = {id:0};
                cmp.onVertposGroupChange({id:0}, true);
              }
              Vue.prototype.$api.getFilterInfo(itemidparts[1], function(data) {
                cmp.currentSearchItem['title'] = data.title;
              });
              // fall through
            case 'range':
            case 'rangeCombo':
              cmp.currentItemData['year'] = [];
              cmp.currentSearchItem.uiYears = data.yearsRelative;
              if (cmp.currentSearchItem.uiYears) {
                cmp.currentSearchItem.uiYears.push(...data.yearsAbsolute);
                for (let y of cmp.currentSearchItem.uiYears) {
                  if (y.preset) {
                    cmp.currentItemData['year'].push(y);
                  }
                }
              }
              cmp.labels['from'] = Vue.i18n.translate('LABEL_SITEM_FROM');
              cmp.labels['to']   = Vue.i18n.translate('LABEL_SITEM_TO');
              if (data.labelSuffix) {
                cmp.labels['from'] += " " + data.labelSuffix;
                cmp.labels['to']   += " " + data.labelSuffix;
              }
              switch (data.unitNr) {
                case 1:
                  cmp.suffix = '%';
                  break;
                case 2:
                  if (data.waehrungsdimensionNr) {
                    cmp.currentItemData['waehrungsdimensionNr'] = "" + data.waehrungsdimensionNr;
                    cmp.onCurrencyDimensionChange();
                  }
                  break;
                case 4:
                  cmp.suffix = 'Tage';
                  break;
                default:
                  cmp.suffix = '';
                  break;
              }
              break;
            case 'regionLandSelect':
            case 'branchSelect':
            case 'gkzSelect':
              cmp.currentItemData['selection'] = [];
              cmp.search = '';
              break;
          }
          if (cmp.currentItemData['selection']) {
            for (let item of cmp.currentSearchItem.uiList) {
              if (item.preset) {
                cmp.currentItemData['selection'].push(item);
              }
            }
          }
          cmp.currentRule = ruleNr ? ruleNr : 0;
          if (ruleData) {
            cmp.currentItemData = JSON.parse(JSON.stringify(ruleData));
            cmp.$nextTick(function () {
              switch (cmp.currentSearchItem.uiElement) {
                case 'regionLandSelect':
                case 'branchSelect':
                case 'gkzSelect':
                  // Open all nodes that are active
                  let path = [];
                  for (let s of cmp.currentItemData['selection']) {
                    Vue.prototype.$api.pathOfNode(path, cmp.currentSearchItem.uiList, s.id);
                  }
                  cmp.openNodes = path;
                  break;
              }
            });
          }
        });
      },
      onSearchItemManagerUpdateData: function (filterLine, data) {
        Vue.prototype.$api.debug('onUpdateItemData', { filterLine: filterLine, data: data });
        this.currentItemData = JSON.parse(JSON.stringify(data));
      },
      onResize: function (event) {
        const view = Vue.prototype.$api.viewport();
        const footerHeight = 36;
        const headerHeight = 60;
        const searchItemTitleHeight = 32 + 16;
        const searchItemInfoLineHeight = 40;

        const filtersetHeight = this.$refs.currentRuleset.clientHeight;

        let h2 = view.height - footerHeight - headerHeight - filtersetHeight - searchItemTitleHeight - searchItemInfoLineHeight;
        this.innerHeight = h2;
        Vue.prototype.$api.debug('innerHeight set to ' + this.innerHeight);
      },
      onFormulaChange: function () {
        Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', true);
        this.saveRules();
        this.updateHits(this.filterRules);
      },
      enableDisableRule: function (rulerNr) {
        Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', true);
        const index = this.filterRules.findIndex(function (item, index) { return item.nr === rulerNr; });
        if (index > -1) {
          this.filterRules[index].enabled = !this.filterRules[index].enabled;
        }
        this.saveRules();
        this.updateHits(this.filterRules);
      },
      deleteRule: function (ruleNr) {
        Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', true);
        this.filterRules.splice(ruleNr-1, 1);
        for (let i in this.filterRules) {
          this.filterRules[i].nr = +i + 1;
        }
        this.formula = '';
        this.saveRules();
        this.updateHits(this.filterRules);
      },
      createSearchFilterFromFilterRule (rule) {
        let entry = {};
        let value = '';
        let format = '';
        
        if (rule.filter.format) {
          format = rule.filter.format.slice(0,1);
        }

        if (!rule.data || (Array.isArray(rule.data) && rule.data.length == 0 && rule.data.keys == 0)) {
          return null;
        }
        switch (rule.filter.uiElement) {
          case "input":
            value = rule.data['value'].trim();
            if (format === 'n') { value = Vue.prototype.$api.parseLocaleNumber(value); }
            break;
          case "checkbox":
            value = rule.data ? true : false;
            break;
          case "multiSelectCombo":
          case "citySelect":
          case "countrySelect":
          case 'regionLandSelect':
          case "branchSelect":
          case "gkzSelect":
            if (rule.data && rule.data['selection'].length > 0) {
              value = [];
              for (let item of rule.data['selection']) {
                value.push(item.id);
              }
            }
            break;
          case "geopos":
            value = {};
            if (rule.data['latitude']) value['latitude'] = Vue.prototype.$api.parseLocaleNumber(rule.data['latitude']);
            if (rule.data['longitude']) value['longitude'] = Vue.prototype.$api.parseLocaleNumber(rule.data['longitude']);
            if (rule.data['radius']) value['radius'] = Vue.prototype.$api.parseLocaleNumber(rule.data['radius']) * 1000;
            let osmdata = Vue.prototype.$api.getCityFromLatLon(value['latitude'], value['longitude']);
            if (osmdata !== undefined) {
              if (osmdata['name']) value['name'] = osmdata['name'];
              if (osmdata['title']) value['title'] = osmdata['title'];
            }
            break;
          case 'vertpos':
          case 'range':
          case 'rangeCombo':
            if (rule.data['upb'] || rule.data['lwb']) {
              let dimension = '';
              value = {};
              if (rule.filter.unitNr === 2) {
                dimension = Vue.prototype.$api.getI18NCurrencyDimension(rule.data['waehrungsdimensionNr']);
                value['waehrungsdimensionNr'] = rule.data['waehrungsdimensionNr'];
                value['currencyNr'] = 2;  // Fix EUR
              }
              if (rule.data['lwb']) {
                value['lwb'] = Vue.prototype.$api.parseLocaleNumber(rule.data['lwb']);
                if (rule.filter.unitNr === 2) value['lwb'] = value['lwb'] * dimension.factor;
              }
              if (rule.data['upb']) {
                value['upb'] = Vue.prototype.$api.parseLocaleNumber(rule.data['upb']);
                if (rule.filter.unitNr === 2) value['upb'] = value['upb'] * dimension.factor;
              }
              if (rule.data['year'] && rule.data['year'].length > 0) {
                value['years'] = [];
                for (let y of rule.data['year']) {
                  value['years'].push(y.id);
                }
              }
            }
            break;            
        }

        // Skip of empty
        if (!value || (Array.isArray(value) && value.length < 1)) {
          return null;
        }

        entry['filterId'] = rule.filter.id;
        if (rule.data['subitem']) {
          entry['filterId'] = Vue.prototype.$api.createSearchFilterId(rule.filter.id, rule.data['subitem'].id);
        }
        entry['value'] = value;
        entry['nr'] = rule.nr;

        return entry;
      },
      onAddRule() {
        this.addRule ();
        return;
      },
      addRule() {
        const cmp = this;
        const rule = {
          nr: this.currentRule ? this.currentRule : this.filterRules.length + 1,
          filter: this.currentSearchItem,
          data: JSON.parse(JSON.stringify(this.currentItemData)),
          enabled: true,
        }

        let filterRule = this.createSearchFilterFromFilterRule(rule);
        if (filterRule == null) {
          return;
        }
        Vue.prototype.$api.getFilterRuleText(filterRule, function (data) {
          rule.displayText = data.displayText;
          if (cmp.currentRule) {
            cmp.filterRules[cmp.currentRule - 1] = rule;
          }
          else  {
            cmp.filterRules.push(rule);
          }
          cmp.saveRules();
          cmp.updateHits([rule]);
          if (cmp.filterRules.length > 1) {
            cmp.updateHits(cmp.filterRules);
          }
          cmp.currentSearchItem = null;
        });
      },
      saveRules() {
        Vue.prototype.storage.saveState('LastRules_' + Vue.prototype.$api.getModuleId() + '_' + this.hitlistMode, {rules: this.filterRules, formula: this.formula, totalHits: this.totalHits, dataSources: this.currentDataSources});
      },
      restoreRules() {
        const data = Vue.prototype.storage.getState('LastRules_' + Vue.prototype.$api.getModuleId() + '_' + this.hitlistMode);
        if (data) {
          this.formula = data.formula;
          this.filterRules = data.rules;
          this.totalHits = data.totalHits;
          this.currentDataSources = data.dataSources ? data.dataSources : [];
        }
      },
      updateHits (rules) {
        const cmp = this;

        let searchData = {};
        searchData['action'] = 'count';
        searchData['mode'] = this.hitlistMode;
        searchData['filter'] = [];
        searchData['sources'] = this.currentDataSources;
        for (let rule of rules) {
          if (rule.enabled) {
            let f = this.createSearchFilterFromFilterRule(rule);
            if (f) searchData['filter'].push(f);
          }
        }
        searchData['columns'] = [ 2 ];
        searchData.mode = this.hitlistMode;
        if (searchData['filter'].length == 0) {
          return;
        }
        if (searchData['filter'].length > 1) {
          searchData['formula'] = this.formula;
        }

        if (rules.length == 1) {
          rules[0].hits = '-';
        }
        cmp.totalHits = '-';
        Vue.prototype.$api.getHitlist(searchData, null, function(data) {
          let text = "{hits} Treffer";
          text = Vue.prototype.$api.formatString(text, {hits: Vue.prototype.$api.formatLocaleNumber('n0', data.totalHits)});
          if (rules.length == 1) {
            rules[0].hits = text;
            if (data.query) {
              rules[0].time = data.execTimeSql;
              rules[0].sql = data.query;
            }
            if (cmp.filterRules.length == 1) {
              cmp.totalHits = text;
              if (data.query) {
                cmp.totals.time = data.execTimeSql;
                cmp.totals.sql = data.query;
              }
            }
          }
          else {
            cmp.totalHits = text;
            if (data.query) {
                cmp.totals.time = data.execTimeSql;
                cmp.totals.sql = data.query;
            }
          }
          cmp.saveRules();
          cmp.$forceUpdate();
        },
        function (xhr, status, error) {
          if (rules.length == 1) {
            rules[0].hits = '';
            if (cmp.filterRules.length == 1) {
              cmp.totalHits = '';
            }
            cmp.onSearchItemManagerClick('', rules[0].filter.id, rules[0].nr, rules[0].data);
          }
          else {
            cmp.totalHits = '';
          }
          Vue.prototype.$api.onAjaxFailure(xhr, status, error);
        });
      },
      onActionButtonClick: function () {
        if (this.showManager) {
          let data = {};
          data.formula = this.formula;
          data.filter = [];
          data.sources = this.currentDataSources;
          data.totalHits = Vue.prototype.$api.parseLocaleNumber(this.totalHits);
          for (let rule of this.filterRules) {
            let f = this.createSearchFilterFromFilterRule(rule);
            if (f && rule.enabled) data['filter'].push(f);
          }
          Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', !this.showManager, data);
        }
        else {
          Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', !this.showManager);
        }
      },
      saveFilterRuleset: function () {
        const cmp = this;
        this.$refs.dlgSaveFilterRuleset.open('TEXT_SM_DIALOG_SAVEFILTERSET', { 
          defaultAnswer: '', //this.currentRulesetName,
        },
        function (answer) {
          let d = {};
          d['formula'] = cmp.formula;
          d['filterRules'] = [];
          for (let rule of cmp.filterRules) {
            let r = {};
            r['data'] = JSON.parse(JSON.stringify(rule.data));
            if (r['data']['selection'] !== undefined) {
              for (let s of r['data']['selection']) {
                if (s['children']) {
                  s['children'] = undefined;
                }
              }
            }
            r['enabled'] = rule.enabled;
            r['nr'] = rule.nr;
            r['filter'] = {};
            r['filter']['Id'] = rule.filter.id;
            if (rule.filter.subId) r['filter']['subId'] = rule.filter.subId;
            d['filterRules'].push(r);
          }

          Vue.prototype.$api.saveFilterRuleset(cmp.hitlistMode, answer, d, function (data) {
            cmp.filterRulesets = data;
          });
        });
      },
      loadFilterRuleset: function (filterRulesetName) {
        Vue.prototype.$eventHub.$emit('SearchRulesManagerAction', true);
        const cmp = this;
        if (filterRulesetName === 'factorydefault') {
          this.filterRules = [];
          this.formula = '';
          this.totalHits = '';
          return;
        }
        Vue.prototype.$api.loadFilterRuleset (this.hitlistMode, filterRulesetName, function (data) {
          let rulesLoaded = 0;
          if (data) {
            cmp.formula = data.formula;
            cmp.filterRules = data.filterRules;
            cmp.totalHits = '-'; //data.totalHits;

            for (let rule of cmp.filterRules) {
              Vue.prototype.$api.getFilterInfo (Vue.prototype.$api.createSearchFilterId(rule.filter.Id, rule.filter.subId), function(data) {
                rule.hits = '0';
                rule.filter = data;
                rulesLoaded ++;
                Vue.prototype.$api.getFilterRuleText(cmp.createSearchFilterFromFilterRule(rule), function (data) {
                  rule.displayText = data.displayText;
                });
                cmp.updateHits([rule]);

                if (cmp.filterRules.length > 1 && cmp.filterRules.length === rulesLoaded) {
                  window.dispatchEvent(new Event('resize'));
                  cmp.updateHits(cmp.filterRules);
                }
              });
            }
          }
        });
      },
      deleteFilterRuleset: function (filterRulesetName) {
        const cmp = this;
        Vue.prototype.$api.deleteFilterRuleset(this.hitlistMode, filterRulesetName, function (data) {
          cmp.filterRulesets = data;
        });
      },
    },
    created() {
      let cmp = this;
      Vue.prototype.$eventHub.$on('SearchItemManagerClick', this.onSearchItemManagerClick);
      Vue.prototype.$eventHub.$on('SearchMaskItemUpdateData', this.onSearchItemManagerUpdateData);
      window.addEventListener("resize", this.onResize);

      this.currentDataSources =  [];
      Vue.prototype.$api.getDataSources(function(data) {
        cmp.dataSources = data;
        cmp.currentDataSources = [];
        for (let s of data) {
          if (s.preset) {
            cmp.currentDataSources.push(s.id);
          }
        }
        if (cmp.currentDataSources.length == 0 && data.length > 0) {
          cmp.currentDataSources.push(data[0].id);
        }
        Vue.prototype.$api.setSelectedSources(cmp.currentDataSources);
      });
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('SearchItemManagerClick', this.onSearchItemManagerClick);
      Vue.prototype.$eventHub.$off('SearchMaskItemUpdateData', this.onSearchItemManagerUpdateData);
      window.removeEventListener("resize", this.onResize);
    },
    mounted() {
      const cmp = this;
      this.first = true;

      this.currencyDimensions = [];
      this.currencyDimensions.push({id: 1, name: "€"})
      for (let i = 2; i <= 3; i++) {
        let dimension = Vue.prototype.$api.getI18NCurrencyDimension(i);
        this.currencyDimensions.push({id: dimension.id, name: dimension.name + " €"})
      }
      Vue.prototype.$api.getFilterRulesets(this.hitlistMode, function (data) {
        cmp.filterRulesets = data;
      });

      this.$nextTick(function () {
        cmp.restoreRules();
        cmp.labels['actionButton'] = Vue.i18n.translate(cmp.showManager ? 'BUTT_HITLIST' : 'BUTT_EDIT');

        window.dispatchEvent(new Event('resize'));
      });
    }
  }
</script>

<style>
.v-tabs__item--active {
  background-color: gainsboro;
}
.v-treeview-node--active {
  background-color: gainsboro !important;
}
.v-list--dense .autoheight .v-list__tile:not(.v-list__tile--avatar) {
  height: auto !important;
}
.v-list__tile__action {
  min-width: max-content !important;
}
.v-list--dense .v-list__tile--avatar {
  height: 60px !important;
}
.singlelineitems {
  white-space: nowrap;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/module/mask/SearchRulesManager.vue